import { DecimalPipe } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { ProgramacionServicio } from 'src/app/domain/model/orden-servicio/orden-servicio';
import {
  IT_DETALLE_TOOLTIP_DESCARGAR_ACTA,
  IT_DETALLE_TOOLTIP_MODIFICAR_HU3
} from '../../services/informacion-tareas-detalle.constants';

@Component({
  selector: 'app-tabla-programaciones-detalle-orden',
  standalone: true,
  imports: [DecimalPipe, ButtonModule, CardModule, TableModule, TooltipModule],
  styleUrls: ['../../../shared/styles/grid-table.styles.scss'],
  template: `
    <p-card header="Programaciones de la tarea">
      <div class="md:hidden space-y-3">
        @if (programaciones().length === 0 && !cargando()) {
          <div
            class="text-center p-4 text-gray-500 border border-gray-200 dark:border-gray-700 rounded-lg"
          >
            {{ mensajeSinProgramaciones() }}
          </div>
        }

        @for (item of programaciones(); track item.nmconsecutivo ?? $index) {
          <div
            class="border border-gray-200 dark:border-gray-700 rounded-lg p-3 bg-white dark:bg-gray-900"
          >
            <div class="grid grid-cols-1 gap-2 text-sm">
              <div>
                <span class="text-gray-500">Id:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  item.nmconsecutivo
                }}</span>
              </div>
              <div>
                <span class="text-gray-500">Tipo cita:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  item.dstipoCita || '-'
                }}</span>
              </div>
              <div>
                <span class="text-gray-500">Consultor:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  item.nombreAsesor || '-'
                }}</span>
              </div>
              <div>
                <span class="text-gray-500">Fecha:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  formatDateTime(item.fechaProgramacion)
                }}</span>
              </div>
              <div>
                <span class="text-gray-500">Duración:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  item.horasCita ?? 0 | number: '1.0-2'
                }}</span>
              </div>
              <div>
                <span class="text-gray-500">Cant. programada:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  item.cantidadProgramada ?? 0 | number: '1.0-2'
                }}</span>
              </div>
              <div>
                <span class="text-gray-500">Cant. ejecutada:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  $any(item).cantidadEjecutada ?? 0 | number: '1.0-2'
                }}</span>
              </div>
              <div>
                <span class="text-gray-500">Estado cita:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  item.estado || '-'
                }}</span>
              </div>
              <div>
                <span class="text-gray-500">Factura:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  $any(item).factura || '-'
                }}</span>
              </div>
              <div>
                <span class="text-gray-500">Estado informe:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  $any(item).estadoInforme || '-'
                }}</span>
              </div>
              <div>
                <span class="text-gray-500">Estado factura:</span>
                <span class="text-gray-800 dark:text-gray-200">{{
                  $any(item).estadoFactura || '-'
                }}</span>
              </div>
            </div>

            <div class="mt-3 grid grid-cols-1 sm:grid-cols-2 gap-2">
              <p-button
                label="Acta 360"
                icon="pi pi-file-pdf"
                severity="secondary"
                [outlined]="true"
                size="small"
                styleClass="w-full min-h-[44px]"
                [loading]="descargandoActaId() === item.nmconsecutivo"
                (onClick)="descargarActa.emit(item)"
              >
              </p-button>
              @if (mostrarColumnaModificar() && puedeMostrarModificar()(item)) {
                <p-button
                  label="Modificar"
                  icon="pi pi-pencil"
                  severity="secondary"
                  [outlined]="true"
                  size="small"
                  styleClass="w-full min-h-[44px]"
                  [pTooltip]="tooltipModificarHu3"
                  (onClick)="modificar.emit(item)"
                >
                </p-button>
              }
            </div>
          </div>
        }
      </div>

      <div class="hidden md:block">
        <p-table
          [resizableColumns]="true"
          columnResizeMode="expand"
          [value]="programaciones()"
          [loading]="cargando()"
          [paginator]="false"
          responsiveLayout="scroll"
          styleClass="tabla-programaciones-detalle-orden p-datatable-sm p-datatable-gridlines"
          [scrollable]="true"
          [tableStyle]="{ 'min-width': '72rem' }"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pResizableColumn>Id</th>
              <th pResizableColumn><span class="grid-header-text" title="Tipo cita">Tipo cita</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Consultor">Consultor</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Fecha programacion">Fecha programacion</span></th>
              <th pResizableColumn class="text-right">Duracion</th>
              <th pResizableColumn class="text-right"><span class="grid-header-text" title="Cant. programada">Cant. programada</span></th>
              <th pResizableColumn class="text-right"><span class="grid-header-text" title="Cant. ejecutada">Cant. ejecutada</span></th>
              <th pResizableColumn><span class="grid-header-text" title="Estado cita">Estado cita</span></th>
              <th pResizableColumn>Factura</th>
              <th pResizableColumn><span class="grid-header-text" title="Estado informe">Estado informe</span></th>
              <th pResizableColumn class="text-center">Acta 360</th>
              <th pResizableColumn><span class="grid-header-text" title="Estado factura">Estado factura</span></th>
              @if (mostrarColumnaModificar()) {
                <th pResizableColumn class="text-center">Modificar</th>
              }
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-item>
            <tr>
              <td>{{ item.nmconsecutivo }}</td>
              <td><span class="grid-cell-text" [attr.title]="item.dstipoCita || '-'">{{ item.dstipoCita || '-' }}</span></td>
              <td><span class="grid-cell-text" [attr.title]="item.nombreAsesor || '-'">{{ item.nombreAsesor || '-' }}</span></td>
              <td>{{ formatDateTime(item.fechaProgramacion) }}</td>
              <td class="text-right">
                {{ item.horasCita ?? 0 | number: '1.0-2' }}
              </td>
              <td class="text-right">
                {{ item.cantidadProgramada ?? 0 | number: '1.0-2' }}
              </td>
              <td class="text-right">
                {{ item.cantidadEjecutada ?? 0 | number: '1.0-2' }}
              </td>
              <td><span class="grid-cell-text" [attr.title]="item.estado || '-'">{{ item.estado || '-' }}</span></td>
              <td>{{ item.factura || '-' }}</td>
              <td><span class="grid-cell-text" [attr.title]="item.estadoInforme || '-'">{{ item.estadoInforme || '-' }}</span></td>
              <td class="text-center">
                <button
                  pButton
                  type="button"
                  icon="pi pi-file-pdf"
                  class="p-button-text p-button-sm min-w-[44px] min-h-[44px]"
                  [loading]="descargandoActaId() === item.nmconsecutivo"
                  [pTooltip]="tooltipDescargarActa"
                  (click)="descargarActa.emit(item)"
                ></button>
              </td>
              <td><span class="grid-cell-text" [attr.title]="item.estadoFactura || '-'">{{ item.estadoFactura || '-' }}</span></td>
              @if (mostrarColumnaModificar()) {
                <td class="text-center">
                  @if (puedeMostrarModificar()(item)) {
                    <button
                      pButton
                      type="button"
                      icon="pi pi-pencil"
                      class="p-button-text p-button-sm min-w-[44px] min-h-[44px]"
                      [pTooltip]="tooltipModificarHu3"
                      (click)="modificar.emit(item)"
                    ></button>
                  }
                </td>
              }
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td
                [attr.colspan]="colspan()"
                class="text-center p-6 text-gray-500"
              >
                {{ mensajeSinProgramaciones() }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  `
})
export class TablaProgramacionesDetalleOrdenComponent {
  programaciones = input<ProgramacionServicio[]>([]);
  cargando = input(false);
  descargandoActaId = input<number | null>(null);
  mostrarColumnaModificar = input(false);
  colspan = input(12);
  mensajeSinProgramaciones = input(
    'No hay programaciones registradas para esta orden'
  );

  puedeMostrarModificar = input<(item: ProgramacionServicio) => boolean>(
    () => false
  );

  descargarActa = output<ProgramacionServicio>();
  modificar = output<ProgramacionServicio>();

  readonly tooltipDescargarActa = IT_DETALLE_TOOLTIP_DESCARGAR_ACTA;
  readonly tooltipModificarHu3 = IT_DETALLE_TOOLTIP_MODIFICAR_HU3;

  formatDateTime(dateValue?: string): string {
    if (!dateValue) {
      return '-';
    }

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) {
      return dateValue;
    }

    return date.toLocaleString('es-CO');
  }
}
